<div class="container mt-4" *ngIf="ndg">
    <h3 class="mt-2 mb-4 d-flex justify-content-center">{{ "survey.anag-info" | translate }}</h3>

    <div class="w-100 d-flex justify-content-center mt-4">
        <table class="table table-striped">
            <tbody>
                <!-- TYPOLOGY -->
                <tr>
                    <th width="40%" scope="row">{{ "ndg.type" | translate }}</th>
                    <td>{{ "survey.domain.ndg.type." + ndg.typology | translate }}</td>
                </tr>

                <!-- FULL NAME -->
                <tr>
                    <th scope="row">{{ "survey.new.ndg-data.name" | translate }}</th>
                    <td>{{ ndg.fullName }}</td>
                </tr>

                <!-- VAT CODE -->
                <tr>
                    <th scope="row">{{ "ndg.vat-number" | translate }}</th>
                    <td>{{ ndg.vatNumber }}</td>
                </tr>

                <!-- NAME -->
                <tr>
                    <th scope="row">{{ "ndg.name" | translate }}</th>
                    <td>{{ ndg.name }}</td>
                </tr>

                <!-- BIRTH DATE -->
                <tr>
                    <th scope="row">{{ "ndg.date-of-birth" | translate }}</th>
                    <td>{{ ndg.dateOfBirth }}</td>
                </tr>

                <!-- FISCAL CODE -->
                <tr>
                    <th scope="row">{{ "ndg.fiscal-code" | translate }}</th>
                    <td>{{ ndg.fiscalCode }}</td>
                </tr>

                <!-- ADDRESS -->
                <tr>
                    <th scope="row">{{ "ndg.address" | translate }}</th>
                    <td>{{ ndg.fullAddress }}</td>
                </tr>

                <!-- PHONE NUMBER -->
                <tr>
                    <th scope="row">{{ "ndg.phone" | translate }}</th>
                    <td>{{ ndg.phone }}</td>
                </tr>

                <!-- EMAIL -->
                <tr>
                    <th scope="row">{{ "ndg.email" | translate }}</th>
                    <td>{{ ndg.email }}</td>
                </tr>

                <!-- INSERT TIME -->
                <tr>
                    <th scope="row">{{ "survey.insert-date" | translate }}</th>
                    <td>{{ ndg.insertTime }}</td>
                </tr>
            </tbody>
        </table>
    </div>

    <div class="w-100 d-flex justify-content-center mt-3" *ngIf="hasInsertPermission()">
        <a class="btn btn-primary" [routerLink]="['../new']">
            {{ "survey.new-label" | translate }}
        </a>
    </div>
</div>

